import { Div } from "./Div";
import { toMap } from "../../../HA";

export class TextField extends Div {
    protected initialize(data: any) {
        if (typeof data === "string") {
            data = toMap({ text: document.createTextNode(data) });
        }
        super.initialize(data);
        this.addClass("tf");
        this.appendChild(this.get("text"));
    }
}
